<div class="onb-grupo-rot">Equipamentos deste computador</div>
<div class="onb-grupo">

  <!-- extensão do WhatsApp -->
  <div class="onb-linha oe-linha">
    <span class="onb-ic oe-ic-whats"><i class="fab fa-whatsapp"></i></span>
    <div class="onb-tx">
      <b>Extensão do WhatsApp</b>
      <span>Com ela, o cliente recebe no WhatsApp cada passo do pedido: aceito, saiu, entregue. Instala no Chrome em 1 minuto.</span>
      <ng-container *ngIf="!extensaoConectada">
        <ol class="oe-passos">
          <li>Toque em <b>Instalar no Chrome</b> e depois em <b>Usar no Chrome</b>.</li>
          <li>Abra o <b>WhatsApp Web</b> com o número da loja<ng-container *ngIf="whatsappLoja">: <b>{{ whatsappLoja }}</b></ng-container>.</li>
          <li>Pronto: esta tela percebe sozinha quando conectar.</li>
        </ol>
        <div class="onb-acoes">
          <a class="onb-btn onb-btn--pri" [href]="linkExtensao" target="_blank" rel="noopener" (click)="instaleExtensao()">
            <i class="fab fa-chrome"></i> Instalar no Chrome
          </a>
          <button type="button" class="onb-btn onb-btn--sec" (click)="jaInstalei()">Já instalei</button>
          <app-onb-video passo="extensao"></app-onb-video>
        </div>
        <p class="oe-erro" *ngIf="erroExtensao">{{ erroExtensao }}</p>
      </ng-container>
    </div>
    <span class="onb-pill onb-pill--ok" *ngIf="extensaoConectada">Conectada</span>
  </div>

  <!-- impressora -->
  <div class="onb-linha oe-linha">
    <span class="onb-ic onb-ic--neutro"><i class="fas fa-print"></i></span>
    <div class="onb-tx">
      <ng-container [ngSwitch]="etapa">
        <ng-container *ngSwitchCase="'pergunta'">
          <b>Impressora térmica <span class="onb-pill">Opcional</span></b>
          <span>Aquela de cupom, que imprime o pedido para a cozinha e para o entregador. Sem ela, o pedido aparece na tela.</span>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--sec" (click)="tenhoImpressora()">
              {{ conectandoQz ? 'Procurando…' : 'Tenho, configurar agora' }}
            </button>
            <a class="onb-btn onb-btn--link" [href]="linkQzTray" target="_blank" rel="noopener"><i class="fas fa-download"></i> Baixar QZ Tray</a>
            <button type="button" class="onb-btn onb-btn--link" (click)="naoTenhoImpressora()">Não tenho</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'nao-tem'">
          <b>Sem impressora</b>
          <span>Tudo bem: o pedido aparece na tela. Se comprar uma, configure depois em Impressão.</span>
          <div class="onb-acoes"><button type="button" class="onb-btn onb-btn--link" (click)="mudarResposta()">Mudar</button></div>
        </ng-container>

        <ng-container *ngSwitchCase="'instalar'">
          <b>Falta o programa de impressão</b>
          <span>O navegador precisa do <b>QZ Tray</b> para falar com a impressora. É gratuito e instala uma vez só.</span>
          <ol class="oe-passos">
            <li>Baixe e instale o QZ Tray (Windows ou Mac): é só avançar até concluir.</li>
            <li>Abra o QZ Tray: o ícone fica perto do relógio (Windows) ou na barra do topo (Mac).</li>
            <li>Se ele pedir permissão para o MeuCardápio, marque <b>Lembrar</b> e clique em <b>Permitir</b>.</li>
            <li>Volte aqui e toque em <b>Procurar a impressora</b>.</li>
          </ol>
          <div class="onb-acoes">
            <a class="onb-btn onb-btn--pri" [href]="linkQzTray" target="_blank" rel="noopener"><i class="fas fa-download"></i> Baixar QZ Tray</a>
            <button type="button" class="onb-btn onb-btn--sec" (click)="conecteQz()">
              {{ conectandoQz ? 'Procurando…' : 'Procurar a impressora' }}
            </button>
            <button type="button" class="onb-btn onb-btn--link" (click)="abraQzTray()">Já tenho, abrir o QZ Tray</button>
            <app-onb-video passo="impressora"></app-onb-video>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'escolher'">
          <b>Qual é a sua impressora?</b>
          <span *ngIf="impressoras.length">Escolha a térmica da lista e a largura da bobina: 80 mm é a larga, a mais comum; 58 mm é a estreita.</span>
          <span *ngIf="!impressoras.length">Nenhuma impressora apareceu. Confira se ela está ligada e instalada no computador.</span>
          <div class="oe-escolha" *ngIf="impressoras.length">
            <select class="onb-inp" id="onb-impressora" [(ngModel)]="impressoraEscolhida" aria-label="Impressora">
              <option value="" disabled>Escolha a impressora</option>
              <option *ngFor="let nome of impressoras" [value]="nome">{{ nome }}</option>
            </select>
            <div class="oe-papel" role="group" aria-label="Papel">
              <button type="button" [class.on]="papel === '80'" (click)="papel = '80'">80 mm</button>
              <button type="button" [class.on]="papel === '58'" (click)="papel = '58'">58 mm</button>
            </div>
          </div>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--pri" (click)="imprimaTeste()">
              <i class="fas fa-print"></i> Imprimir página de teste
            </button>
            <button type="button" class="onb-btn onb-btn--link" (click)="conecteQz()">Procurar de novo</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'testando'">
          <b>Saiu a página de teste?</b>
          <span>Ela tem o nome da sua loja e um pedido de exemplo.</span>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--pri" (click)="saiu()">Saiu</button>
            <button type="button" class="onb-btn onb-btn--sec" (click)="naoSaiu()">Não saiu</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'saiu'">
          <b>Impressora pronta</b>
          <span>Os pedidos aceitos saem impressos. Dá para ajustar o layout em Impressão.</span>
        </ng-container>

        <ng-container *ngSwitchCase="'falhou'">
          <b>Vamos resolver</b>
          <span>Confira: impressora ligada, com papel, luz verde acesa e cabo no computador (ou na mesma rede). O QZ Tray precisa estar aberto.</span>
          <p class="oe-erro" *ngIf="erroImpressora">{{ erroImpressora }}</p>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--sec" (click)="conecteQz()">Tentar de novo</button>
            <button type="button" class="onb-btn onb-btn--pri" (click)="pecaAjuda()"><i class="far fa-question-circle"></i> Falar com o suporte</button>
          </div>
        </ng-container>
      </ng-container>

      <details class="oe-guia" *ngIf="etapa === 'pergunta' || etapa === 'escolher' || etapa === 'falhou'">
        <summary>Como configurar a impressora, passo a passo</summary>
        <ol class="oe-passos">
          <li><b>Ligue a impressora no computador</b> pelo cabo USB (ou na mesma rede) e confira se ela já aparece em Impressoras do Windows ou do Mac.</li>
          <li><b>Baixe e instale o <a [href]="linkQzTray" target="_blank" rel="noopener">QZ Tray</a></b>, gratuito. É ele que deixa o navegador falar com a impressora.</li>
          <li><b>Abra o QZ Tray.</b> Se ele pedir permissão para o MeuCardápio, marque <b>Lembrar</b> e clique em <b>Permitir</b>.</li>
          <li><b>Volte aqui</b>, toque em <b>Tenho, configurar agora</b>, escolha a impressora e a largura do papel.</li>
          <li><b>Imprima a página de teste.</b> Saiu? Pronto: todo pedido aceito sai no papel.</li>
        </ol>
        <p class="oe-dica">Deixe o QZ Tray abrindo junto com o computador (ele pergunta na instalação). Se a impressão parar um dia, é quase sempre ele fechado.</p>
        <div class="onb-acoes"><app-onb-video passo="impressora"></app-onb-video></div>
      </details>
    </div>
    <span class="onb-pill onb-pill--ok" *ngIf="etapa === 'saiu'">Pronta</span>
  </div>
</div>
<p class="onb-nota">Nada disso impede o pedido de teste. Dá para fazer depois, voltando a este passo.</p>
